export default __webpack_public_path__ + "static/InfoLinks_Hover-d061f427f45b1c95c4089aa1abe7cfe7.png";